import { MapPin } from "lucide-react";
import { SHOWROOMS } from "@/data/showrooms";

export default function TopBar() {
  return (
    <div data-testid="top-bar" className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-2 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-x-8 gap-y-1 text-[10px] tracking-[0.18em] uppercase">
        {SHOWROOMS.map((s) => (
          <a
            key={s.id}
            href={s.link}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`topbar-showroom-${s.id}`}
            className="inline-flex items-center gap-1.5 text-primary-foreground/75 hover:text-primary-foreground transition-colors duration-300"
          >
            <MapPin className="w-3 h-3 text-[#E23B4E]" />
            <span className="hidden sm:inline text-primary-foreground/45">{s.label}:</span> {s.name}
          </a>
        ))}
      </div>
    </div>
  );
}
